import { ActionIcon, Menu, Text } from "@marketplace/ui";
import { useAtomValue, useSetAtom } from "jotai";
import { useTranslation } from "react-i18next";
import { MdMoreVert } from "react-icons/md";

import { userDataAtom } from "@/modules/auth/atoms/auth-atom";

import { deleteVoucherModalAtom } from "../../atoms";
import type { VoucherListItem } from "../../types";

type VoucherListTableActionsProps = {
  voucherData: VoucherListItem;
};

export const VoucherListTableActions = ({
  voucherData
}: VoucherListTableActionsProps) => {
  const { t } = useTranslation("voucher", {
    keyPrefix: "voucherListPage.tableActions"
  });
  const setDeleteVoucherModal = useSetAtom(deleteVoucherModalAtom);
  const userData = useAtomValue(userDataAtom);

  const handleDelete = () => {
    try {
      setDeleteVoucherModal({
        visible: true,
        data: voucherData
      });
    } catch (e) {
      console.error(e);
    }
  };

  const userRoles = userData?.roles || [];
  const canDelete = userRoles.some((role) =>
    ["seller", "seller-admin", "superadmin"].includes(role)
  );

  if (!canDelete) {
    return null;
  }

  return (
    <Menu width={120} position="bottom-end">
      <Menu.Target>
        <ActionIcon variant="transparent" className="text-fjord-grey-500">
          <MdMoreVert size={24} />
        </ActionIcon>
      </Menu.Target>

      <Menu.Dropdown>
        <Menu.Item onClick={handleDelete}>
          <Text size="s" className="text-fjord-grey-500">
            {t("delete")}
          </Text>
        </Menu.Item>
      </Menu.Dropdown>
    </Menu>
  );
};
